module.exports = __webpack_public_path__ + "static/media/bgphoto.9f7fce24.png";